import { useCallback, useState } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import PopupResult from '@r1-frontend/ui-react/components/popups/popupResult';

import { DefaultCallback } from '~/src/features/specialOffersContainer/constants';
import { IProps } from '~/src/features/specialOffersContainer/types';
import { capitalize } from '~/src/helpers/string';

const PromoConnectionPopup = ({ isPopupOpen, offer, callbackMap, onClose }: IProps<typeof DefaultCallback>): JSX.Element => {
    const { billingState, isLoading, isConnecting } = offer || {};

    const [isLocalLoading, setIsLocalLoading] = useState(false);

    const actionText = billingState === 'connected' ? 'отключить' : 'подключить';

    const onConnectHandler = useCallback(async() => {
        if (!offer) {
            return;
        }

        setIsLocalLoading(true);
        const { callback } = callbackMap['onActivate'](offer);
        await callback().finally(() => setIsLocalLoading(false));
    }, [callbackMap, offer]);

    return (
        <PopupResult
            isOpen={isPopupOpen}
            title={`Вы уверены, что хотите ${actionText} предложение?`}
            onClose={onClose}
        >
            <ButtonGroup>
                <Button
                    size={'large'}
                    bType={'action'}
                    loading={isConnecting || isLocalLoading}
                    disabled={isLoading}
                    onClick={onConnectHandler}
                >
                    {capitalize(actionText)}
                </Button>
                <Button
                    size={'large'}
                    bType={'secondary'}
                    disabled={isConnecting}
                    onClick={onClose}
                >
                    Закрыть
                </Button>
            </ButtonGroup>
        </PopupResult>
    );
};

export default PromoConnectionPopup;
